<template>
  <div class="h-screen bg-black overflow-hidden">
    <MetaTags :slug="$route.params.slug || ''" />
    <AppWallpaper />
    <AppDesktop 
      ref="desktop"
      @window-update="handleWindowUpdate"
      @document-update="handleDocumentUpdate"
    />
    <AppTaskbar
      :open-windows="openWindows"
      :open-documents="openDocuments"
      @window-click="handleTaskbarWindowClick"
      @document-click="handleTaskbarDocumentClick"
      @toggle-applications="toggleApplications"
    />
  </div>
</template>

<script>
import MetaTags from './components/MetaTags.vue';
import AppWallpaper from './components/AppWallpaper.vue';
import AppDesktop from './components/AppDesktop.vue';
import AppTaskbar from './components/AppTaskbar.vue';

export default {
  name: 'App',
  components: {
    MetaTags,
    AppWallpaper,
    AppDesktop,
    AppTaskbar
  },
  data() {
    return {
      openWindows: [],
      openDocuments: []
    };
  },
  watch: {
    // Watch for route changes
    '$route': {
      immediate: true,
      handler(to) {
        // Wait for desktop component to be mounted
        this.$nextTick(() => {
          if (to.params.slug && this.$refs.desktop) {
            this.$refs.desktop.openDocumentBySlug(to.params.slug);
          }
        });
      }
    }
  },
  methods: {
    handleWindowUpdate(windows) {
      this.openWindows = windows;
    },
    handleDocumentUpdate(documents) {
      this.openDocuments = documents;
    },
    handleTaskbarWindowClick(window) {
      this.$refs.desktop.toggleWindow(window);
    },
    handleTaskbarDocumentClick(doc) {
      this.$refs.desktop.toggleDocument(doc);
    },
    toggleApplications() {
      this.$refs.desktop.toggleApplicationsMenu();
    }
  }
};
</script>
